import React, { AllHTMLAttributes, FC } from 'react';

import { cn } from '../../../utils';

import './Section.scoped.scss';

interface Props extends AllHTMLAttributes<HTMLDivElement> {}

const Section: FC<Props> = ({ children, ...props }) => {
  return (
    <section {...props} className={cn('section', props.className)}>
      {children}
    </section>
  );
};

export default Section;
